import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import LoginPage from "./modules/student-portal/pages/login-page/login-page";
import Dashboard from "./modules/student-portal/pages/dashboard/dashboard";
import SingleSurveyPage from "./modules/student-portal/pages/single-survey-page/single-survey-page";

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/" component={LoginPage} />
          <Route exact path="/dashboard" component={Dashboard} />
          <Route exact path="/survey" component={SingleSurveyPage} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
